import axios from "../axiosInstance";
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Pagination from '../components/Pagination';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Sidebar from '../components/sidebar';
import { errorMessage, paymentMethodFormat } from "../hooks/UserLogs";
import Topbar from "../components/topbar";

export default function AccountingOpWallet() {
    const [view, setView] = useState(false);
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [isLoading, setIsLoading] = useState(true);
    const [ListAgencies, setListAgencies] = useState([]);
    const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
    const [showError, setShowError] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('');
    const convertToDate=(resultDate)=>{
        const yyyy = resultDate.getFullYear();
        let mm = resultDate.getMonth(); // Months start at 0!
        let dd = resultDate.getDate();
        mm=mm+1;
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return yyyy+'-'+mm+'-'+dd+'T00:00:00.000Z';
      }
    
      let defaultBgDate = new Date()
      defaultBgDate.setDate(defaultBgDate.getDate() - 7)
      let defaultEndDate = new Date();
      defaultEndDate.setDate(defaultEndDate.getDate() +1)
      const [beginDate,setBeginDate]=useState(defaultBgDate);
      const [endDate,setEnDate]=useState(defaultEndDate);

    let header =
    {
        'Content-Type': 'application/json'
    };
    const viewClose = () => {
        setView(false)
    }
    const viewOpen = () => {
        setView(true)
    }
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }
    const [listAccountingOp, setListAccountingOp] = useState([]);
    const bUrl = process.env.REACT_APP_B_URL;
    const { id } = useParams();
    const getAccountingOpWallet = async (bgDate,edDate,paymentMethod) => {

        setBeginDate(new Date(bgDate));
        setEnDate(new Date(edDate));
        setPaymentMethod(paymentMethod);
        let url=bUrl + "/accounting-op-Wallet/with-accounting?idAccounting=" + id + "&page=" + currentPage + "&limit=10";
        if(paymentMethod!= '' || bgDate!= '' || edDate!= ''){
            url=bUrl + "/accounting-op-Wallet/with-accounting/search?idAccounting=" + id + "&page=" + currentPage + "&limit=10";
        
            if(paymentMethod!= ''){
                url+="&paymentMethod="+paymentMethod;
            }
            if(bgDate!= ''){
                url+="&beginDate="+convertToDate(new Date(bgDate));
            }

            if( endDate!= '') {
                url +=  "&endDate=" + convertToDate(new Date(new Date(endDate)));
            }
        }

        const response = await axios.get(url).catch((err) => {
            setIsLoading(false);
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
                setShowError(true);
            } else {
                let msg = errMsg = + ' ' + err?.response?.status;
                seterrMsg(msg);
                setShowError(true);
            }

        });

        if (response) {
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                seterrMsg(msg);
                setShowError(true);
            } else {
                setListAccountingOp(response.data.body);
                setTotalPage(response.data.totalPage);
                setCurrentPage(response.data.currentPage);
            }

            setIsLoading(false);
        }
    }

    const handleCloseError = () => {
        setShowError(false);
    }

    useEffect(() => {
        getAccountingOpWallet(beginDate,endDate,paymentMethod);
    }, [currentPage])
    return (
        <>
            <div>
                <Sidebar />
                <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                                            <div><p className='fw-bold'>Revenus des ventes d'electricité par agent</p></div>
                                            <div><Topbar /></div>
                                          </div>
                                          <div className="table-content mt-3 p-3">
                                            <div className="d-flex justify-content-around">
                                              <div className="form-group text">
                                                <label htmlFor="exampleInputEmail1">Début</label>
                                                <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getAccountingOpWallet(e.target.value, endDate, paymentMethod)} className="form-control" id="exampleInputEmail1"  />
                                              </div>
                                              <div className="form-group text">
                                                <label htmlFor="phone">Fin</label>
                                                <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getAccountingOpWallet(beginDate, e.target.value, paymentMethod)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                                              </div>
                                              <div className="form-group text">
                                                <label htmlFor="code">Type</label>
                                                <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={paymentMethod}  onChange={(e) => getAccountingOpWallet(beginDate, endDate, e.target.value)}>
                                                      <option value="">Sélectionnez</option>
                                                      <option value="DP">Dépot</option>
                                                      <option value="AM">Marchand Appro</option>
                                                      <option value="SM">Agence Appro</option>
                                                      <option value="WF">Facture</option>
                                                      
                                                  </select>
                                              </div>
                                            </div>
                                          </div>
                            <div className="table-content mt-3 p-3">
                                <button onClick={() => viewOpen()}>
                                    <i className='bx bx-plus icon'></i>
                                </button>
                                <div className="table-responsive-xl">
                                    {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                                        <table className="table text">
                                            <thead>
                                                <tr>
                                                    <th scope="col">id</th>
                                                    <th scope="col">crédité</th>
                                                    <th scope="col">débité</th>
                                                    <th scope="col">Type</th>
                                                    <th scope="col">Tansaction</th>

                                                    <th scope="col">Nouvelle Balance</th>
                                                    <th scope="col">Date</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listAccountingOp.length > 0 ? listAccountingOp.map((a, i) => {
                                                    return <tr key={i}>
                                                        <td>{i}</td>
                                                        <td>{a.credited}</td>
                                                        <td>{a.deBited}</td>
                                                        <td>{paymentMethodFormat(a.paymentMode)}</td>

                                                        {(a.paymentMode === 'SM' || a.paymentMode === 'AM') ?
                                                            <td><Link to={"/invoiceStartupMaster/" + a.fkIdInvoiceStartupMaster}> Détails</Link></td>
                                                            : (a.paymentMode === 'DP') ?
                                                                <td><Link to={"/invoiceagent/" + a.fkIdInvoiceWalletAgent}>Détails</Link></td>
                                                                :
                                                                <td><Link to={"/biller/" + a.fkIdBillerInvoice}>Détails</Link></td>
                                                        }
                                                        <td>{a.newBalance}</td>
                                                        <td>{formatDate(a.createdDate)}</td>


                                                    </tr>
                                                }) : <tr></tr>}

                                            </tbody>
                                        </table>
                                    }
                                </div>
                                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
                            </div>
                        </div>
                        <Modal show={showError} onHide={handleCloseError} className="">
                            <Modal.Header closeButton className="bg-danger">
                                <Modal.Title>ERROR</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseError}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </section>
            </div>

        </>
    )
}
